module.exports = __webpack_public_path__ + "assets/images/project/japanese-cemetery/01.jpg?v=15fe8e44";